import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Formatter } from '../../services/formatter';
import { PlanDetailsService } from '../../services/planDetails.service';
import { SessionHandlerService } from "../../services/sessionHandler.service";
import { CommonConstants } from "../../utilities/commonConstants";
import { GoogleAnalyticsService } from './../../services/google_analytics.service';
@Component({
  selector: 'app-plan-card',
  templateUrl: './planCard.template.html',
  styleUrls: ['./planCard.style.scss']
})
export class PlanCardComponent implements OnInit {

  @Input() itemSelected;
  @Input() i = 0;
  @Input() selectedSumAssured;
  @Input() selectedSumAssuredAddOn;
  @Input() totalGrossPremium;
  @Input() cashlessHospitalcount;
  @Input() aemFragmentInfo;
  @Input() featureHide;
  @Input() planCode;
  @Input() variantCode;
  @Input() tags;
  @Input() selectedTenure;
  @Input() pageType;
  @Input() section;
  @Input() analyticsObj;
  @Input() appQuoteCriteriaId;

  isPartnerLogoLoaded: boolean;

  @Output() brochureCtaClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() policyCtaClicked: EventEmitter<boolean> = new EventEmitter<boolean>();


  constructor(
    public formatter: Formatter,
    private _planDetailsService: PlanDetailsService,
    private _sessionHandlerService: SessionHandlerService,
    private _googleAnalyticsService: GoogleAnalyticsService
  ) { }

  ngOnInit() {
    if (this.variantCode)
      this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.variantCode, this.variantCode);

    console.log(this.planCode);
    console.log(this.variantCode);
  }

  public isLogoLoaded(color, id) {
    console.log(color, id);
    const elem: any = document.getElementsByClassName('card-object-header1');
    console.log(elem);
    console.log(typeof elem[id]);
    Array.from(elem).forEach((element: any) => {
      element.style.setProperty('background-color', color);
      for (let i = 0; i < element.children.length; i++) {
        element.children[i].style.setProperty('background-color', color);
        const childArray = element.children[i].querySelectorAll('*');
        for (let j = 0; j < childArray.length; j++) {
          if (childArray[j].className !== 'partner-logo') {
            childArray[j].style.setProperty('background-color', color);
          }
        }
      }
    });
    if (!!elem[id]) {
      elem[id].style.setProperty('background-color', color);
    }
    this.isPartnerLogoLoaded = true;
  }


  // Download Plan Brochure
  public DownloadBrochure(link) {

    if (link) {
      window.open(link);
    }
  }

  public googleAnalyticDownload(text) {
    let partnerName = '';
    let partnerPlanName = '';

    if (!!this.aemFragmentInfo) {
      partnerPlanName =
        this.aemFragmentInfo.productName.variations[this.planCode.toLowerCase() + '_' + this.variantCode.toLowerCase()].value;
      partnerName =
        this.aemFragmentInfo.principleName.variations[this.planCode.toLowerCase() + '_' + this.variantCode.toLowerCase()].value;
    }
    this._googleAnalyticsService.pushToDataLayer({
      'event': 'link_click',
      'pageType': this.pageType,                   //E.g. Product Listing Page, Cashless Hospital Page, Select Tenure Page
      'productid': 'HGI',             //E.g. HGI
      'productName': 'Health Insurance',                //E.g. Health Insurance, Motor Insurance
      'partnerName': partnerName,                //E.g. Aditya Birla Health Insurance, Bajaj Allianz General Insurance
      'partnerPlanName': partnerPlanName,            //E.g. Active Assure Diamond,Individual Health Guard - Gold Plan 
      'premiumAmount': `Rs.${this.formatter.ToCurrency(this.totalGrossPremium.toString())}`,         //E.g. Rs.6,371, Rs.8,402
      'sumInsured': `Rs.${this.formatter.ConvertNumberToAmount(this.selectedSumAssured.toString())}`,            //E.g. 5 Lac, 6 Lac, etc.
      'tenure': `${this.analyticsObj.tenure} Year`,              //E.g. 1 Year, 2 Years, etc.
      'section': this.section,         //E.g. Tenure, Insured Member Details, etc.
      'clickText': `Download - ${text}`,        //E.g. Download - Brochure, Policy Wording
      'mobile': this.analyticsObj.mobile,
      'dob': this.analyticsObj.dob,
      'insuringFor': this.analyticsObj.insuringFor,
      'pinCode': this.analyticsObj.pinCode,
      'city': this.analyticsObj.city,
      'appQuoteCriteriaId': this.appQuoteCriteriaId,
      'stagePercentage': this.analyticsObj.stagePercentage,
      'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
    });
  }

  handleCtBrochure() {
    this.brochureCtaClicked.emit();
  }

  handleCtPolicy() {
    this.policyCtaClicked.emit();
  }


}
